export default "__VITE_ASSET__BjLnfn1P__"